<template>
  <div class="not-found">
    <h1>Page Not Found: {{$route.fullPath}}</h1>
  </div>
</template>
